// extracted by mini-css-extract-plugin
export var contentBody = "_5i-9";
export var headerImage = "_5i-2";
export var imageButton = "_5i-7";
export var imageButtonIcon = "_5i-8";
export var imageHeader = "_5i-4";
export var imageHeaderText = "_5i-5";
export var imageOverlay = "_5i-3";
export var imageTitle = "_5i-6";
export var imageWrapper = "_5i-1";
export var taskList = "_5i-a";
export var widget = "_5i-0";